import React, { useEffect } from "react";
import { divIcon } from "leaflet";
import {
  MapContainer as LeafletMap,
  TileLayer,
  WMSTileLayer,
  Marker,
  Tooltip,
  ScaleControl,
  ZoomControl,
  GeoJSON,
  useMap,
} from "react-leaflet";
import styled from "styled-components";

import "./MapContainer.css";
import KOREA_MAP from "../data/map/KOREA-MAP-V3.json";
import { MAP_URLS } from "../data/basicStructure";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const DEFAULT_CENTER = [35.9078, 128.0];
const DEFAULT_ZOOM = 7;

function FitBoundsView({ totalSpots, targetRegion }) {
  const map = useMap();
  const totalSpotsRef = React.useRef(totalSpots);
  totalSpotsRef.current = totalSpots;

  useEffect(() => {
    const spots = totalSpotsRef.current;
    if (!targetRegion || targetRegion.region === "all") {
      map.setView(DEFAULT_CENTER, DEFAULT_ZOOM, { animate: false });
      return;
    }
    const filtered = spots.filter((s) => s.region === targetRegion.region);
    if (filtered.length === 0) return;
    if (filtered.length === 1) {
      map.setView([filtered[0].latitude, filtered[0].longitude], 11, { animate: false });
      return;
    }
    const lats = filtered.map((s) => s.latitude);
    const lons = filtered.map((s) => s.longitude);
    map.fitBounds(
      [[Math.min(...lats), Math.min(...lons)], [Math.max(...lats), Math.max(...lons)]],
      { padding: [40, 40], animate: false }
    );
  }, [targetRegion?.region]);
  return null;
}

const AlimtalkMapContainer = ({ totalSpots = [], selectSpot, targetRegion }) => {
  const onEachFeature = (feature, layer) => {
    layer.on({ mouseover: () => {}, mouseout: () => {}, click: () => {} });
  };

  return (
    <Wrapper>
      <LeafletMap
        center={DEFAULT_CENTER}
        zoom={DEFAULT_ZOOM}
        minZoom={6}
        style={{ width: "100%", height: "100%" }}
        zoomControl={false}
      >
        <FitBoundsView totalSpots={totalSpots} targetRegion={targetRegion} />
        <ZoomControl position="bottomleft" />
        <ScaleControl metric={true} imperial={false} />
        <TileLayer url={MAP_URLS.satellite} attribution="VWORLD" />
        <WMSTileLayer url={MAP_URLS.hybrid} />
        {totalSpots.map((spot) => {
          const size = 18;
          const markerHtml = `<div style="
                background:${spot.is_same.color};
                opacity:0.8;
                width:${size}px;
                height:${size}px !important;
                border-radius:50%;
                border: 1px solid ${spot.is_same.borderColor};
                line-height:${size}px;
              "></div>`;

          return (
            <Marker
              key={spot.id ?? `${spot.region}-${spot.latitude}-${spot.longitude}`}
              position={[spot.latitude, spot.longitude]}
              eventHandlers={{ click: () => selectSpot && selectSpot(spot) }}
              icon={divIcon({
                className: "custom-marker",
                iconSize: [size, size],
                iconAnchor: [size / 2, size / 2],
                html: markerHtml,
              })}
            >
              <Tooltip>
                <div>
                  <strong>{`${spot.regionName}-${spot.name}` ?? "-"}</strong>
                  <br />
                  지점 코드: {spot.code ?? "-"}
                  <br />
                  총 계획 발송 차수: {spot.total ?? "-"}차
                  <br/>
                  현재 진행 발송 차수: {
                      spot.now
                          ? (spot.now === spot.total ? '종료' : `${spot.now}차`)
                          : '개화전'
                    }
                  <br />
                  최근 발송일자: {spot.recentSentDt ?? "-"}
                </div>
              </Tooltip>
            </Marker>
          );
        })}
        <GeoJSON
          color="black"
          weight={2}
          opacity={0.5}
          fillColor="white"
          data={KOREA_MAP}
          onEachFeature={onEachFeature}
        />
      </LeafletMap>
    </Wrapper>
  );
};

export default AlimtalkMapContainer;
